<div class="container">
  <div class="container header">
    <div class="header__title_container">
      <h3 class="header__title_container__title">User Sampling</h3>
      <div class="header__title_container__button" [ngClass]="{'disabled': !userSamplingEnabled}">
        <app-icon (click)="addNewRow()" iconName="plus-circle" iconStyle="far"></app-icon>
      </div>
    </div>
    <div>
      <form-factory [formGroup]="userSamplingSwitchGroup" [model]="userSamplingActiveSwitch"
        (onChange)="onUserSamplingSwitchChange($event)"></form-factory>
      <p style="width: 50%">
        Set individual review rates (“Overread”) for first-pass abstractors. User Sampling is in additions to any
        Project and Measure Sampling configurations. For instance, a 100% user sampling will ensure all of that abstractor's
        tasks
        are reviewed,
        regardless of the project's sampling rate.</p>
    </div>
  </div>
  <div *ngIf="userSamplingEnabled" class="user-sampling-table">
    <table class="table">
      <tr>
        <td>Full Name</td>
        <td>Sampling Type</td>
        <td>Sampling Count</td>
        <td></td>
      </tr>
      <ng-container *ngFor="let group of userRowGroup; let i = index; trackBy: trackByIndex">
        <tr>
          <ng-container *ngFor="let row of getControls(group.formGroup); let j = index; trackBy: trackByIndex">
            <td style="padding: 0.25rem">
              <form-factory class="input" [formGroup]="group.formGroup" [model]="group.userModels[j]">
              </form-factory>
            </td>
          </ng-container>
          <td>
            <div *ngIf="canDeleteRow(group)" class="action-button">
              <app-icon (click)="deleteRow(i)" iconName="fa-regular fa-trash"></app-icon>
            </div>
          </td>
        </tr>
      </ng-container>
    </table>
  </div>
</div>
